/**
 * It's a generated file, preferable to extend this in external file
 */
import * as yup from 'common/yup';
import {enums} from 'types/enums';

export const SyncMatchSpecification = yup.object({
   pattern: yup.string(),
   patternType: yup.string().oneOf(enums.patternType.keys).default(enums.patternType.enum.STRING),
   recursive: yup.boolean().default(true),
   caseSensitive: yup.boolean(),
   includedObjects: yup
      .string()
      .oneOf(enums.includedObjects.keys)
      .default(enums.includedObjects.enum.BOTH),
});
export type ISyncMatchSpecification = yup.InferType<typeof SyncMatchSpecification>;
